// Reuse the active worker after reload, and wait for a first installation.
let registrationPromise;

export async function prepareDesktopNotifications(requestPermission = false) {
  if (!window.isSecureContext || typeof Notification === 'undefined' ||
      !('serviceWorker' in navigator)) {
    throw new Error('Для уведомлений нужен HTTPS и поддержка уведомлений браузером.');
  }
  const permission = requestPermission
    ? await Notification.requestPermission() : Notification.permission;
  if (permission !== 'granted') {
    throw new Error('Уведомления не разрешены в настройках браузера.');
  }
  if (!registrationPromise) {
    registrationPromise = navigator.serviceWorker.register('/service-worker.js')
      .then(() => navigator.serviceWorker.ready)
      .catch(error => {
        registrationPromise = null;
        throw error;
      });
  }
  return registrationPromise;
}

export async function showDesktopNotification(title, options) {
  const registration = await prepareDesktopNotifications();
  return registration.showNotification(title, options);
}
